import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'

Vue.component('app-gestaorelatorio-grid', grid)
Vue.component('app-gestaorelatorio-edit', edit)
